// @ts-nocheck
import { type ApolloCache, ApolloClient } from "@apollo/client";
import { getAffectedGroups, getCachedAffectedGroups } from "../queries/getAffectedGroups";
import {
    type GetAffectedGroupsQueryVariables,
    type GetCachedAffectedGroupsQuery,
    type GetCachedAffectedGroupsQueryVariables,
} from "../queries/getAffectedGroups.gql-generated";
import { CacheRepository } from "../../../data/cache";
import { AffectedGroupsOperations } from "./AffectedGroupsOperations";

export class AffectedGroupsRepository extends CacheRepository {
    public static initDefaults(cache: ApolloCache<any>) {
        cache.writeQuery<Partial<GetCachedAffectedGroupsQuery>, GetCachedAffectedGroupsQueryVariables>({
            query: getCachedAffectedGroups,
            data: {
                __typename: "Query",
                getAffectedGroups: {
                    affectedGroups: [],
                    cursor: "",
                    __typename: "LenssourceGetAffectedGroupsResponse",
                },
            },
        });
    }

    public loadAffectedGroupsToCache(variables: Partial<GetAffectedGroupsQueryVariables>) {
        const cacheData = this.read<GetCachedAffectedGroupsQuery>(getCachedAffectedGroups);
        const newVariables = {
            ...variables,
            cursor: cacheData?.getAffectedGroups.cursor,
        };

        return this.load(getAffectedGroups, getCachedAffectedGroups, newVariables, AffectedGroupsOperations.concat);
    }
}
